/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable no-console */
/* eslint-disable no-shadow */
import { Helmet } from 'react-helmet-async';
import { useSelector } from 'react-redux';
import { useState } from 'react';
// @mui
import {
  Grid,
  Container,
  Typography,
  Card,
  CardHeader,
  Box,
  Stack,
  Radio,
  RadioGroup,
  FormControlLabel,
  List,
  ListItem,
  ListItemText,
  IconButton,
  Divider,
  Alert,
} from '@mui/material';
import { useSnackbar } from 'notistack';
import { LoadingButton } from '@mui/lab';
import DeleteIcon from '@mui/icons-material/Delete';
import cronstrue from 'cronstrue';
import { Cron } from 'react-js-cron';
import chalk from 'chalk';
import { DateTime } from 'luxon';
// eslint-disable-next-line no-unused-vars
import axiosInstance from '../utils/axiosInstance';
import SingleSelector from '../components/single-selector/singleSelector';
import 'react-js-cron/dist/styles.css';

const { log } = console;

export default function RecordSettings() {
  const [camera, setCamera] = useState(null);
  const [schedule, setSchedule] = useState([]);
  const [startSchedule, setStartSchedule] = useState('');
  const [endSchedule, setEndSchedule] = useState('');
  const { enqueueSnackbar } = useSnackbar();
  const [recordingStatus, setRecordingStatus] = useState(false);
  const cameraList = useSelector((state) => state.app.cameraList);

  /**
   * TODO: FIX THIS FUNCTION
   */
  const changeSchedulesToLocal = (scheduleArr) => scheduleArr;
  function subtractOneFromLastDigit(inputString) {
    const parts = inputString.split(' ');
    if (parts.length === 5) {
      const lastDigit = parseInt(parts[4], 10);
      if (!Number.isNaN(lastDigit)) {
        parts[4] = (lastDigit - 1).toString();
        return parts.join(' ');
      }
    }
    return inputString;
  }
  const changeSchedulesToUTC = (scheduleArr) => {
    const temp = [];

    scheduleArr.forEach((obj) => {
      const startParts = obj.startTime.split(' ');
      const endParts = obj.endTime.split(' ');

      const localStart = DateTime.fromObject({
        minute: parseInt(startParts[0], 10),
        hour: parseInt(startParts[1], 10),
        weekday: parseInt(startParts[4], 10) + 1,
      });

      const localEnd = DateTime.fromObject({
        minute: parseInt(endParts[0], 10),
        hour: parseInt(endParts[1], 10),
        weekday: parseInt(endParts[4], 10) + 1,
      });

      const utcStart = localStart.toUTC();
      const utcEnd = localEnd.toUTC();

      temp.push({
        startTime: subtractOneFromLastDigit(utcStart.toFormat('m H * * E')),
        endTime: subtractOneFromLastDigit(utcEnd.toFormat('m H * * E')),
      });
    });

    return temp;
  };

  const getSchedule = (camera) => {
    setSchedule([]);
    axiosInstance
      .get(`${window.location.protocol}//${camera.host}/api/v1/record/${camera.sensorId}/schedule`)
      .then((response) => {
        console.log(response.data);
        if (response.data) {
          log(chalk.blue('received schedule: '), response.data);
          setSchedule(changeSchedulesToLocal(response.data));
        }
      })
      .catch((error) => {
        console.log('Failed to get record schedule', error);
        if (error.response.data == null) {
          enqueueSnackbar(`Error - ${error.response.status}`, {
            variant: 'error',
            anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
          });
        } else {
          enqueueSnackbar(`Error - ${camera.name} ${error.response.data.error_message}`, {
            variant: 'error',
            anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
          });
        }
      });
  };

  const getRecordingStatus = (camera) => {
    setRecordingStatus(null);
    axiosInstance
      .get(`${window.location.protocol}//${camera.host}/api/v1/record/${camera.sensorId}/status`)
      .then((response) => {
        console.log('recording status: ', response.data);
        if (response.data) {
          setRecordingStatus(response.data.recordingStatus);
        }
      })
      .catch((error) => {
        if (error.response.data == null) {
          enqueueSnackbar(`Error - ${error.response.status}`, {
            variant: 'error',
            anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
          });
        } else {
          enqueueSnackbar(`Error - ${camera.name} ${error.response.data.error_message}`, {
            variant: 'error',
            anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
          });
        }
        console.log('Failed to get record status', error);
      });
  };

  const handleCameraSelect = (cam) => {
    setCamera(cam);
    if (!cam) {
      setRecordingStatus(null);
      setSchedule([]);
    } else {
      getSchedule(cam);
      getRecordingStatus(cam);
    }
  };

  const handleRecordingChange = (e) => {
    let action = '';
    if (e.target.value === 'off') {
      action = 'stop';
    } else if (e.target.value === 'user') {
      action = 'start';
    } else {
      return;
    }
    const url = `${window.location.protocol}//${camera.host}/api/v1/record/${camera.sensorId}/${action}`;
    axiosInstance
      .post(url)
      .then((response) => {
        console.log(response.data);
        setRecordingStatus(action === 'stop' ? 'off' : 'user');
        enqueueSnackbar('Success - recording status changed', {
          variant: 'success',
          anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
        });
      })
      .catch((error) => {
        console.log('Failed to set record schedule', error);
        if (error.response.data == null) {
          enqueueSnackbar(`Error - ${error.response.status}`, {
            variant: 'error',
            anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
          });
        } else {
          enqueueSnackbar(`Error - ${camera.name} ${error.response.data.error_message}`, {
            variant: 'error',
            anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
          });
        }
      });
  };

  const handleDeleteSchedule = (obj) => {
    console.log('start_time for del schedule', obj.startTime);
    console.log('end_time for del schedule', obj.endTime);
    axiosInstance
      .delete(
        `${window.location.protocol}//${camera.host}/api/v1/record/${camera.sensorId}/schedule?startTime=${obj.startTime}&endTime=${obj.endTime}`,
      )
      .then((response) => {
        console.log(response.data);
        getSchedule(camera);
      })
      .catch((error) => {
        console.log('Failed to delete record schedule', error);
        if (error.response.data == null) {
          enqueueSnackbar(`Error - ${error.response.status}`, {
            variant: 'error',
            anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
          });
        } else {
          enqueueSnackbar(`Error - ${camera.name} ${error.response.data.error_message}`, {
            variant: 'error',
            anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
          });
        }
      });
  };

  const regexTest = (input) => {
    const regex = /[0-9]+ [0-9]+ \* \* [0-9]+/i;
    console.log(input, regex.test(input));
    return regex.test(input);
  };

  const handleSubmitSchedule = async () => {
    console.log('endSchedule: ', endSchedule);
    console.log('startSchedule: ', startSchedule);
    if (!regexTest(endSchedule) || !regexTest(startSchedule)) {
      enqueueSnackbar('Error - Invalid schedule', {
        variant: 'error',
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
      });
      return;
    }
    const jsonData = await changeSchedulesToUTC([
      {
        endTime: endSchedule,
        startTime: startSchedule,
      },
    ]);
    console.log('jsonData: ', jsonData);
    axiosInstance
      .post(`${window.location.protocol}//${camera.host}/api/v1/record/${camera.sensorId}/schedule`, jsonData)
      .then((response) => {
        console.log(response.data);
        getSchedule(camera);
        enqueueSnackbar('Success - recording schedule changed', {
          variant: 'success',
          anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
        });
      })
      .catch((error) => {
        console.log('Failed to get record status', error);
        if (error.response.data == null) {
          enqueueSnackbar(`Error - ${error.response.status}`, {
            variant: 'error',
            anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
          });
        } else {
          enqueueSnackbar(`Error - ${camera.name} ${error.response.data.error_message}`, {
            variant: 'error',
            anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
          });
        }
      });
  };

  // Function to filter authorized cameras
  const filterAuthorized = (cameraList) => cameraList
    .filter((camera) => camera.isAuthorized === true);

  return (
    <>
      <Helmet>
        <title> Record settings </title>
      </Helmet>

      <Container maxWidth="xl">
        <Typography variant="h4" sx={{ mb: 5 }}>
          Record settings
        </Typography>

        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={12}>
            <Card>
              <CardHeader title="Record settings" subheader="Set and view camera record settings" />
              <Box sx={{ p: 3 }}>
                <Stack spacing={3} sx={{ mb: 2 }}>
                  <SingleSelector
                    id="camera-details"
                    placeholder="Type to search"
                    label="Select camera"
                    value={camera}
                    onChange={handleCameraSelect}
                    getOptionLabel={(option) => {
                      if (option.remoteDeviceName && option.remoteDeviceLocation) {
                        return `${option.name} at ${option.remoteDeviceName} (${option.remoteDeviceLocation})`;
                      } if (option.remoteDeviceName) {
                        return `${option.name} at ${option.remoteDeviceName}`;
                      }
                      return option.name;

                    }}
                    options={filterAuthorized(cameraList)}
                  />
                </Stack>
              </Box>
            </Card>
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <Card>
              <CardHeader title="Recording status" subheader="Set status" />
              <Box sx={{ p: 3 }}>
                <RadioGroup value={recordingStatus} onChange={handleRecordingChange}>
                  <FormControlLabel value="off" control={<Radio />} label="Off" />
                  <FormControlLabel value="user" control={<Radio />} label="On" />
                </RadioGroup>
                {camera && recordingStatus && (
                  <Alert severity="info">
                    Recording status of
                    {' '}
                    {camera.name}
                    {' '}
                    is
                    {' '}
                    <b>{recordingStatus.replace(/_/g, ' ')}</b>
                    .
                  </Alert>
                )}
              </Box>
            </Card>
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <Card>
              <CardHeader title="Recording schedule" subheader="Set record schedule" />
              <Box sx={{ p: 3 }}>
                <Typography variant="button" sx={{ mb: 1 }}>
                  Start time:
                </Typography>
                <Cron
                  value={startSchedule}
                  setValue={setStartSchedule}
                  clearButton={false}
                  allowedPeriods={['week']}
                  allowedDropdowns={['week-days', 'hours', 'minutes']}
                  periodicityOnDoubleClick={false}
                  humanizeLabels
                  defaultValue="@daily"
                  defaultPeriod="week"
                  mode="single"
                  clockFormat="12-hour-clock"
                />
                <Typography variant="button" sx={{ mb: 1 }}>
                  End time:
                </Typography>
                <Cron
                  value={endSchedule}
                  setValue={setEndSchedule}
                  clearButton={false}
                  allowedPeriods={['week']}
                  allowedDropdowns={['week-days', 'hours', 'minutes']}
                  periodicityOnDoubleClick={false}
                  humanizeLabels
                  defaultValue="@daily"
                  defaultPeriod="week"
                  mode="single"
                  clockFormat="12-hour-clock"
                />
              </Box>
              <Box m={1} display="flex" justifyContent="flex-end" alignItems="flex-end">
                <LoadingButton
                  size="large"
                  type="submit"
                  variant="contained"
                  onClick={handleSubmitSchedule}
                  sx={{ m: 1 }}
                >
                  Submit
                </LoadingButton>
              </Box>
            </Card>
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            <Card>
              <CardHeader title="Existing schedules (UTC time)" subheader="List of existing schedules" />
              <Box sx={{ p: 3 }}>
                <List>
                  {schedule.map((obj, index) => (
                    <ListItem
                      key={obj.startTime + index}
                      secondaryAction={(
                        <IconButton
                          edge="end"
                          onClick={() => {
                            handleDeleteSchedule(obj);
                          }}
                        >
                          <DeleteIcon sx={{ color: 'error.main' }} />
                        </IconButton>
                      )}
                    >
                      <ListItemText
                        primary={(
                          <>
                            <ul>
                              <li>
                                Start at
                                {cronstrue.toString(obj.startTime)}
                              </li>
                              <li>
                                End at
                                {cronstrue.toString(obj.endTime)}
                              </li>
                            </ul>
                            {index !== schedule.length - 1 && <Divider sx={{ my: 2 }} />}
                          </>
                        )}
                      />
                    </ListItem>
                  ))}
                </List>
              </Box>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
